import * as React from 'react';
import Box from '@mui/material/Box';

import Modal from '@mui/material/Modal';
import { Stack } from '@mui/system';
// import { height } from '@mui/system';
import { Viewer, Worker } from '@react-pdf-viewer/core';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { IoClose } from 'react-icons/io5';
import { CircularProgress, Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  height: '80%',
  objectFit: 'contain',
  overflow: 'hidden',
  bgcolor: 'background.paper',
  border: '0px solid #000',
  boxShadow: 24,
  p: 4
};

export default function ImageModal(props) {
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const zoomPluginInstance = zoomPlugin();
  return (
    <>
      <Modal open={props.open} onClose={props.handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        {props.IsLoading ? (
          <Box sx={style}>
            <Stack justifyContent="center" alignItems="center" width="100%">
              <CircularProgress />
            </Stack>
          </Box>
        ) : (
          <Box sx={style}>
            <Box
              sx={{
                position: 'absolute',
                top: 10,
                right: 10,
                fontSize: '24px',
                cursor: 'pointer'
              }}
              onClick={props.handleClose}
            >
              {<IoClose />}
            </Box>
            <Typography sx={{ position: 'absolute', top: 5, left: 5, zIndex: 2 }}>{props.fileType}</Typography>
            <Stack>
              {props.fileType === 'pdf' ? (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <div style={{ height: '600px', overflow: 'auto' }}>
                    <Viewer fileUrl={props.image} plugins={[pageNavigationPluginInstance, zoomPluginInstance]} />
                  </div>
                </Worker>
              ) : (
                <img src={props.image} alt="img" style={{ width: '100%', aspectRatio: 1, objectFit: 'contain' }} />
              )}
            </Stack>
          </Box>
        )}
      </Modal>
    </>
  );
}
